import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import campaignColumnTemplate from './campaign-column.pug';
import { InlineEditableColumnPrompt } from './inline-editable/prompt';

export class ColumnCampaign extends CampaignuiBaseColumn {
  constructor({ i18n, view }) {
    super({
      name: 'Campaign',
      type: 'string',
      property: _.compact([
        'Id',
        'Name',
        'BaseCampaignName',
      ]),
      sortable: 'Name',
      title: 'ColumnName_Campaign',
      bodyClasses: ['col-CampaignName'],
      i18n,
    });

    this.i18n = i18n;
    this.view = view;
  }

  template({ value }) {
    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const link = `#customer/${cid}/account/${aid}/campaign/${value.cmpid}/edit`;
    return campaignColumnTemplate({
      link,
      name: value.name,
      baseCampaignName: value.baseCampaignName,
    });
  }

  get property() {
    return {
      get: ({ Id, Name, BaseCampaignName }) => ({
        cmpid: Id,
        name: Name,
        baseCampaignName: BaseCampaignName,
      }),
      key: this.config.property,
    };
  }

  onPrompt({ event, position, item }) {
    if (event.target.tagName.toLowerCase() === 'a') {
      return undefined;
    }

    // Store current campaign name before updating it
    const currentName = item.Name;

    return InlineEditableColumnPrompt({
      position,
      item,
      schema: TargetingSettingsContext.CampaignSchema,
      view: this.view,
      i18n: this.i18n,
      fieldName: 'Name',
      successCallback: (updated) => {
        // Since the currently edited Campaign may also be the BaseCampaign of
        // other Experimental Campaigns in this grid, check and update.
        _.each(this.view.grid.gridView.itemArray, (rowItem) => {
          if (rowItem.BaseCampaignName === currentName) {
            const updatedRowItem = _.defaults({
              BaseCampaignName: updated.Name,
            }, rowItem);

            this.view.grid.gridView.trigger('didEdit', updatedRowItem);
          }
        });

        // update wunderbar
        window.App.trigger('campaignUpdated', { data: [_.pick(updated, 'Id', 'Name')] });
      },
    });
  }
}
